"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAttachGlobalProductTreeToCatalog = void 0;
const react_1 = require("react");
const react_2 = require("@apollo/client/react");
const attach_product_tree_to_catalog_mutation_1 = require("./attach-product-tree-to-catalog.mutation");
const get_global_product_tree_query_1 = require("./get-global-product-tree.query");
const client_utils_1 = require("../client.utils");
const useAttachGlobalProductTreeToCatalog = () => {
    const [getGlobalProductTree] = (0, react_2.useLazyQuery)(get_global_product_tree_query_1.GET_GLOBAL_PRODUCT_TREE, { fetchPolicy: 'network-only' });
    const [attachProductTreeToCatalogMutation] = (0, react_2.useMutation)(attach_product_tree_to_catalog_mutation_1.ATTACH_PRODUCT_TREE_TO_CATALOG);
    const attachGlobalProductTreeToCatalog = (0, react_1.useCallback)((options) => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b;
        const getGlobalProductTreeResponse = yield getGlobalProductTree();
        (0, client_utils_1.genericGraphQLErrorsHandler)(getGlobalProductTreeResponse);
        const { id } = (_b = (_a = getGlobalProductTreeResponse.data.productTrees.edges[0]) === null || _a === void 0 ? void 0 : _a.node) !== null && _b !== void 0 ? _b : {};
        if (!id) {
            throw new Error('No product trees were found');
        }
        const attachProductTreeToCatalogResponse = yield attachProductTreeToCatalogMutation({
            variables: Object.assign(Object.assign({}, options.variables), { productTreeId: id }),
        });
        (0, client_utils_1.genericGraphQLErrorsHandler)(attachProductTreeToCatalogResponse);
        return attachProductTreeToCatalogResponse;
    }), [attachProductTreeToCatalogMutation, getGlobalProductTree]);
    return {
        attachGlobalProductTreeToCatalog,
    };
};
exports.useAttachGlobalProductTreeToCatalog = useAttachGlobalProductTreeToCatalog;
exports.default = exports.useAttachGlobalProductTreeToCatalog;
